/*
  Arrows for the product carousel.

  The carousel itself is a plain overflow scroller with no JS — that stays true.
  This only adds optional arrows that step it one card at a time, so the section
  still works completely if the script never loads.
*/
(function () {
  'use strict';

  function setup(root) {
    if (root.pcReady) return;
    root.pcReady = true;

    var viewport = root.querySelector('[data-pc-viewport]');
    var prev = root.querySelector('[data-pc-prev]');
    var next = root.querySelector('[data-pc-next]');
    if (!viewport || !prev || !next) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* One card plus the gap. Measured from the DOM rather than the settings, so
       it stays right whatever slides-per-view is set to at this breakpoint. */
    function step() {
      var slide = viewport.querySelector('.ss-pc__slide');
      if (!slide) return viewport.clientWidth;
      var styles = window.getComputedStyle(slide.parentElement);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      // A pixel of slack: scrollLeft can land fractionally short of the end.
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= max - 1;

      // Nothing to scroll — hide rather than show two dead controls.
      root.classList.toggle('ss-pc--scrollable', max > 1);

      prev.disabled = atStart;
      next.disabled = atEnd;
    }

    function go(direction) {
      viewport.scrollBy({
        left: step() * direction,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Cards load lazily, so the scrollable width is not final at DOMContentLoaded.
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(viewport.querySelector('.ss-pc__track') || viewport);
    }

    update();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-pc-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
